<template>
  <div
    class="px:6 w-full overflow-hidden pt-3 md:px-10"
    v-if="notification.length > 0"
  >
    <swiper :options="options">
      <swiper-slide v-for="(item, index) in notification" :key="index">
        <div class="mx-auto max-w-7xl px-6">
          <div :class="item.color" class="rounded-lg p-2 shadow-lg sm:p-3">
            <div class="flex flex-wrap items-center justify-between">
              <div class="flex w-0 flex-1 items-center">
                <span :class="item.color" class="flex rounded-lg p-2">
                  <span
                    class="text-ontick-carbon-500"
                    v-html="$icons.bell"
                  ></span>
                </span>
                <p class="ml-3 truncate text-ontick-carbon-500">
                  <span class="font-medium">
                    {{ item.title }}
                  </span>
                  <span class="text-semibold px-6 text-sm">
                    {{ item.message }}
                  </span>
                </p>
              </div>
              <div
                class="order-3 mt-2 w-full flex-shrink-0 sm:order-2 sm:mt-0 sm:w-auto"
              >
                <button
                  @click="activeModal(item.history_id)"
                  v-show="item.topic == 'Activation'"
                  class="flex items-center justify-center rounded-md border border-transparent bg-gray-300 px-4 py-2 text-sm font-medium text-ontick-carbon-500 shadow-sm"
                >
                  Clique aqui
                </button>
              </div>
              <div class="order-2 flex-shrink-0 sm:order-3 sm:ml-2">
                <button
                  @click="removerNotification(item.nf_id, item.history_id)"
                  type="button"
                  class="focus:outline-none -mr-1 flex rounded-md p-2 focus:ring-2 focus:ring-white"
                >
                  <span v-html="$icons.close"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <modal-notification
      v-if="active"
      :active="active"
      :id="history_id"
      @close="active = false"
    />
  </div>
</template>

<script>
import EventBus from "@/app/shared/utils/event_bus";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import modalNotification from "./modal.component";
import { mapState } from "vuex";

export default {
  name: "notificationUrgent",
  components: { Swiper, SwiperSlide, modalNotification },

  data() {
    return {
      active: false,
      history_id: 0,
      notification: [],
      options: {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 10,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },

  computed: {
    ...mapState({
      notification_all: (state) => state.notification.notification_all,
    }),
  },

  watch: {
    notification_all(value) {
      this.message(value);
      return value;
    },
  },

  methods: {
    selectedColor(value) {
      let color = "";
      if (value == "Activation") {
        color = "bg-ontick-yellow-800 text-ontick-yellow-800";
      } else {
        color = "bg-ontick-blue-800 text-ontick-blue-300";
      }
      return color;
    },

    textColor(value) {
      let color = "";
      if (value == "Activation") {
        color = " text-ontick-yellow-300";
      } else {
        color = "  text-ontick-blue-300";
      }
      return color;
    },

    message(payload) {
      let new_notification = {};
      new_notification = payload.data[0];

      if (
        new_notification.type == "URGENT" ||
        new_notification.type == "FIXED"
      ) {
        this.notification.push(new_notification);
      }
    },

    removerNotification(value) {
      let index = this.notification.indexOf(value);
      this.notification.splice(index, 1);

      value = parseInt(value);

      let nf_id = { nf_id: value };

      this.$api
        .post(this.$endpoint.POST_NOTIFICATIONS_READ, nf_id)
        .then(() => {});
    },

    activeModal(history_id) {
      this.active = true;
      this.history_id = history_id;
    },
  },
};
</script>

<style></style>
